import { useCallback, useEffect, useState } from 'react';

/**
 * PDFページナビゲーションロジックを管理するカスタムフック
 *
 * @param onPageChange - ページ変更時のコールバック
 * @param scrollContainerRef - スクロールコンテナへの参照
 * @returns ページ状態とページ変更ハンドラー
 */
export const usePdfNavigation = (
  onPageChange?: (page: number) => void,
  scrollContainerRef?: React.RefObject<HTMLDivElement | null>,
  controlledPage?: number
) => {
  const [page, setPage] = useState<number>(1);

  const scrollToTop = useCallback(() => {
    if (scrollContainerRef?.current) {
      scrollContainerRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }

    setTimeout(() => {
      if (scrollContainerRef?.current) {
        scrollContainerRef.current.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    }, 150);
  }, [scrollContainerRef]);

  /**
   * ページ変更ハンドラー
   * ページ変更時にPDF表示エリアの上部にスクロールします
   */
  const handlePageChange = useCallback(
    (newPage: number): void => {
      setPage(newPage);

      if (onPageChange) {
        onPageChange(newPage);
      }

      scrollToTop();
    },
    [onPageChange, scrollToTop]
  );

  useEffect(() => {
    if (typeof controlledPage === 'number' && controlledPage >= 1 && controlledPage !== page) {
      setPage(controlledPage);
      scrollToTop();
    }
  }, [controlledPage, page, scrollToTop]);

  return {
    page,
    setPage,
    handlePageChange,
  };
};
